import React, { ReactNode } from 'react';
import Stack, { StackProps } from '../Stack/Stack';
import Text from '../Text/Text';

type Props = {
  children: ReactNode;

  title?: ReactNode;

  accessory?: ReactNode;
};

const TableSection = ({
  children,
  title,
  accessory,
  ...rest
}: Props & StackProps) => {
  return (
    <Stack bg="white" px={3} py={3} {...rest}>
      {(title || accessory) && (
        <Stack pb={1} row justifyContent="space-between">
          {title &&
            (typeof title === 'string' ? (
              <Text variant="h4">{title}</Text>
            ) : (
              title
            ))}
          {accessory && accessory}
        </Stack>
      )}
      {children}
    </Stack>
  );
};

TableSection.displayName = 'TableSection';
export default TableSection;
